/**
 * Perfil del usuario en localStorage: la UI (DashboardNavbar) lee HumanName.
 * El ID token no se persiste; se pide a Firebase en cada request.
 */

const KEYS = {
  token: "token",
  refreshToken: "refresh-token",
  humanName: "HumanName",
  userName: "userName",
};

export function persistSession({ displayName, email }) {
  if (displayName) {
    localStorage.setItem(KEYS.humanName, displayName);
  }

  // Hoy: local-part del email. Misma regla para no romper expectativas.
  if (email && email.includes("@")) {
    localStorage.setItem(KEYS.userName, email.split("@")[0]);
  }
}

export function clearSession() {
  Object.values(KEYS).forEach((key) => localStorage.removeItem(key));
}
